import { Link, useLocation } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const isOffensiveSecurityPage = location.pathname === '/services/cybersecurity/offensive-security';

  return (
    <footer 
      className={`pt-16 pb-8 transition-colors duration-300 ${isOffensiveSecurityPage ? 'bg-black text-white' : 'text-white'}`}
      style={!isOffensiveSecurityPage ? {
        background: `
          radial-gradient(ellipse 60% 90% at 100% 50%, #3b82f6 0%, #1d4ed8 22%, #1e3a8a 45%, #0f172a 70%, #070b18 100%),
          linear-gradient(to right, #060b18 0%, #0f172a 30%, #1e3a8a 60%, #1d4ed8 100%)
        `,
        backgroundBlendMode: 'screen',
      } : undefined}
    >
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          <div className="-mt-8">
            <div className="mb-0 flex justify-center md:justify-start">
              <img src="/Logos/atlasdefenders_white_logo.svg" alt="Atlas Defenders" className="h-32 md:h-48 w-auto" />
            </div>
            <p className="mb-6 text-gray-300 -mt-8 relative z-10">
              Leading IT and cybersecurity services provider in Morocco, delivering enterprise-grade solutions to protect your digital assets.
            </p>
            <div className="flex space-x-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-300 hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-300 hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-lg font-medium mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/industries" className="text-gray-300 hover:text-white transition-colors">Industries</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link>
              </li>
            </ul>
          </div>


          <div>
            <h4 className="text-white text-lg font-medium mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="flex-shrink-0 mt-1 text-accent" />
                <span className="text-gray-300">Marina Business Center, Tour Crystal 1, 10éme étage, Casablanca, Morocco</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={20} className="flex-shrink-0 text-accent" />
                <span className="text-gray-300">+212 659097623</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="flex-shrink-0 text-accent" />
                <a href="mailto:contact@atlasdefenders.com" className="text-gray-300 hover:text-white transition-colors">contact@atlasdefenders.com</a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-gray-700 mb-8" />

        <div className="flex flex-col items-center justify-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} Atlas Defenders. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
